interface Option {
  id: string;
  name: string;
  values: string[];
}

interface VariantSelectorProps {
  options: Option[];
  selectedOptions: Record<string, string>;
  onSelect: (optionName: string, value: string) => void;
  unavailableOptions: Set<string>;
}

export default function VariantSelector({
  options,
  selectedOptions,
  onSelect,
  unavailableOptions,
}: VariantSelectorProps) {
  if (!options.length) return null;

  return (
    <div className="space-y-6">
      {options.map((option) => (
        <div key={option.id}>
          <p className="text-gray-400 text-xs tracking-widest uppercase mb-3">
            {option.name}:{' '}
            <span className="text-white font-semibold">{selectedOptions[option.name]}</span>
          </p>
          <div className="flex flex-wrap gap-2">
            {option.values.map((value) => {
              const key = `${option.name}:${value}`;
              const isSelected = selectedOptions[option.name] === value;
              const isUnavailable = unavailableOptions.has(key);

              return (
                <button
                  key={value}
                  onClick={() => !isUnavailable && onSelect(option.name, value)}
                  disabled={isUnavailable}
                  className={`relative px-5 py-2 rounded-full text-sm font-semibold tracking-wide transition-all duration-300 cursor-pointer whitespace-nowrap ${
                    isSelected
                      ? 'bg-[#00d4ff] text-black shadow-[0_0_16px_rgba(0,212,255,0.6)]'
                      : isUnavailable
                      ? 'bg-[#1a1a1a] text-gray-600 border border-gray-800 cursor-not-allowed'
                      : 'bg-[#1a1a1a] text-white border border-gray-700 hover:border-[#00d4ff]/60 hover:text-[#00d4ff]'
                  }`}
                >
                  {isUnavailable && (
                    <span className="absolute inset-0 flex items-center justify-center pointer-events-none">
                      <span className="absolute w-full h-px bg-gray-600 rotate-[-20deg]"></span>
                    </span>
                  )}
                  {value}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
